import { component } from 'picoapp'
import { addVariant } from '@/lib/cart.js'

export default component((node, ctx) => {
  const form = node.querySelector('[data-upsell-form]');
  const { selectedOrFirstAvailableVariant, product } = JSON.parse(node.querySelector('.upsell-item-data').innerHTML);
  let currentVariant = product.variants.filter((v) => v.id === selectedOrFirstAvailableVariant)[0]

  const buttonText = node.querySelector('.upsell__item--addToCart');

  form.addEventListener('submit', e => {
    e.preventDefault()

    buttonText.innerHTML = theme.strings.addingToCart

    addVariant(currentVariant, form.elements.quantity.value, function(){
      buttonText.innerHTML = theme.strings.addToCart
    })
  });

})